import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentSection, Fieldset, Layout, Modal } from '@vwfs-bronson/bronson-react';
import { SetState } from '../../../services/common/miscUtils.types';
import { useNavigate } from '../../../services/routing/navigate';

interface Props {
  visible: boolean;
  isCoCustomer: boolean;
  hasCoCustomer: boolean;
  setShowConsentModal: SetState<boolean>;
}

export const ConsentModal: FunctionComponent<Props> = ({
  visible,
  isCoCustomer,
  hasCoCustomer,
  setShowConsentModal,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onConfirm = () => {
    setShowConsentModal(false);

    if (hasCoCustomer && !isCoCustomer) {
      navigate.form(2, '/coContractor');
    } else {
      navigate.form('/3');
    }
  };

  return (
    <Modal
      id="consentModel"
      shown={visible}
      onConfirm={onConfirm}
      buttonConfirmText={t(`step2:consentModal:closeBtn`)}
      title={t(`step2:consentModal:title`)}
      hideTitle
    >
      <ContentSection pageWrap>
        <Fieldset>
          <Layout>
            <Fieldset.Row>
              <Layout.Item default="1/1" className="u-text-center u-mv-none">
                {t(`step2:dataConsent:personalDataCollection`)}
              </Layout.Item>
            </Fieldset.Row>
          </Layout>
        </Fieldset>
      </ContentSection>
    </Modal>
  );
};
